export var getItemAnimationDelay = function getItemAnimationDelay(_ref) {
  var delayInMs = _ref.delayInMs,
      itemIndex = _ref.itemIndex,
      _ref$multiplier = _ref.multiplier,
      multiplier = _ref$multiplier === void 0 ? 12 : _ref$multiplier;
  var ITEM_NUMBER = itemIndex + 1;
  return "".concat(Math.round((ITEM_NUMBER * ITEM_NUMBER / 2 - Math.log(ITEM_NUMBER * ITEM_NUMBER)) * multiplier + delayInMs), "ms");
};